export default "__VITE_ASSET__C$nOiiVC__"